import React from 'react'
import styles from '~/styles/atoms/bar/bar.module.scss'

import { addClass } from '~/common/utils/html'
import { GeneralIconTag } from '~/common/define/icon'
import { IconColor, IconSize } from '~/components/atoms/icon/Icon'
import IconText from '~/components/atoms/icon/IconText'
import ExternalLink from '~/components/atoms/link/ExternalLink'

interface Props {
  text: string
  link?: string
  // onClose(): void
}

const NotificationBar = ({text, link, /*onClose*/}: Props) => {
  const Tag = link ? ExternalLink : 'div'
  return (
    <Tag className={styles.notification + addClass(styles.notification__link, !!link)} link={link}>
      <IconText tag={GeneralIconTag.BELL} size={IconSize.X_SMALL} fillColor={IconColor.YELLOW}>
        {text}
      </IconText>
      {/*<span className={styles.message__close} onClick={onClose}>*/}
      {/*   <Icon tag={GeneralIconTag.CLOSE} size={IconSize.SMALL} rotate/>*/}
      {/*</span>*/}
    </Tag>
  )
}

export default NotificationBar